import { takeLatest, put, call } from 'redux-saga/effects';

import { listContaCartaoCadastro } from '../service';
import {
  TABLE_CONTA_CARTAO_CADASTRO,
  TABLE_CONTA_CARTAO_CADASTRO_PENDING,
  TABLE_CONTA_CARTAO_CADASTRO_SUCCESS,
  TABLE_CONTA_CARTAO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListContaCartaoCadastro(action) {
  yield put({ type: TABLE_CONTA_CARTAO_CADASTRO_PENDING })

  try {
    const table = yield call(listContaCartaoCadastro, action.args)
    yield put({ type: TABLE_CONTA_CARTAO_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CONTA_CARTAO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListContaCartaoCadastro() {
  yield takeLatest(TABLE_CONTA_CARTAO_CADASTRO, sagaListContaCartaoCadastro)
}